import React, { useState, useEffect } from "react";
import Form from "react-bootstrap/Form";
import InputGroup from 'react-bootstrap/InputGroup';
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { useSelector, useDispatch } from "react-redux";
import MasterList from "../../../common/MasterList";
import { useTranslation } from "react-i18next";
import Constants from "../../../../common/Constants";
import ChecklistForm from "./ChecklistForm";
import { AlertModal } from "../../../common/AlertModal";

import {
  fetchMasterList,
  addMasterRecord,
  deleteMasterRecord,
  searchMasterList,
} from "../../../../redux/feature/manufacturing_app/commonMasterListSlice";
import { toastFunc } from "../../../../components/common/util";
import { ConfirmationModal } from "../../../common/ConfirmationModal";
import { ErrorModal } from "../../../common/errorModal";
import { formatDateTime } from "../../../../common/Validations";

const Checklist = () => {
  const [open, setOpen] = useState(false);
  const [isError, setIsError] = useState(false);
  const [error, setError] = useState("");
  const [selectedItem, setSelectedItem] = useState([]);
  const [confirmModel, setConfirmModel] = useState(false);
  const [editMachines, setEditMachines] = useState();
  const [isAlert, setIsAlert] = useState(false);
  const [searchValue,setSearchValue] = useState();

  localStorage.setItem("menu", "Dashboard");
  localStorage.setItem("submenu", "-");
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const handleClose = () => {
    setOpen(false);
  };

  const handleSave = (data, edit) => {
    const param = { ...data };
    if (!edit) {
      param.method = Constants.MASTER.CHECKLIST.ADD;
    } else {
      param.method = Constants.MASTER.CHECKLIST.UPDATE;
    }
    param.edit = edit;
    dispatch(addMasterRecord(param)).then((res) => {
      //   console.log(">> item >>", res);
      if (res?.payload?.status === 200) {
        toastFunc(
          Constants.MASTER.TOAST.success,
          t("msg_master_list.msg_department.success_message"),
          2000
        );
        dispatch(fetchMasterList(Constants.MASTER.CHECKLIST)); // userSlice store
        setOpen(false);
      } else {
        //toastFunc(Constants.MASTER.TOAST.error,t("msg_master_list.msg_department.invalid_input"),4000)
        setError(res.payload.message);
        setIsError(true);
      }
    });
  };

  const handleOpen = (data) => {
    if (data) {
      setEditMachines(data);
    }
    setOpen(true);
  };

  useEffect(() => {
    dispatch(fetchMasterList(Constants.MASTER.CHECKLIST)); // userSlice store
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleRowSelected = ({ selectedRows }) => {
    const selectChecklists = selectedRows.map(item => item.checklistCode);
    setSelectedItem([...selectChecklists]);
  };
  const resetAlert = () => {
    setIsAlert(false);
  };
  const resetError = () => {
    setIsError(false);
    setError("");
  };
  const confirmBeforeDelete = (data, singleDelete = false) => {
    if (singleDelete) {
      setSelectedItem([data.checklistCode]);
      setConfirmModel(true);
    } else {
      if (selectedItem.length === 0) {
        setIsAlert(true);
        return
      } else {
        setConfirmModel(true);
      }
    }
  };

  const handleDelete = () => {
    let param = {};
    param.custList = selectedItem;
    param.method = Constants.MASTER.CHECKLIST.DELETE;
    dispatch(deleteMasterRecord(param)).then((res) => {
      if (res?.payload?.status === 200) {
        toastFunc(
          Constants.MASTER.TOAST.success,
          t("msg_master_list.msg_checklist.delete_success_message"),
          2000
        );
        dispatch(fetchMasterList(Constants.MASTER.CHECKLIST));
        setSelectedItem([]);
        setConfirmModel(false);
      } else {
        setError(res.payload.message);
        setIsError(true);
        toastFunc(
          Constants.MASTER.TOAST.error,
          t("msg_master_list.msg_checklist.invalid_input"),
          4000
        );
      }
    });
  };

  let masterList = useSelector((state) => state?.masterList?.page); // User Details from Store
  let rowsData = masterList[Constants.MASTER.CHECKLIST.name]?.data;

  const handleSearch = () => {
    const param = { 
     ...Constants.MASTER.CHECKLIST,
      value: searchValue };
    if(searchValue){
      dispatch(searchMasterList(param)).then((res) => {
        if (res?.payload?.status === 200) {
          rowsData = res?.payload?.data;
        }
      });
    }
  };

  const onSearchChange = (e) => {
    if(e.target.value){
      setSearchValue(e.target.value)  
    }else{
      dispatch(fetchMasterList(Constants.MASTER.CHECKLIST))
      setSearchValue(e.target.value)
    }
  };

  const columnsData = [
    {
      name: t("msg_common.actions"),
      cell: (row) => (
        <>
          <span>
            <i
              className="bi bi-pencil-square iconTable"
              onClick={() => handleOpen(row)}
            ></i>
          </span>
          <span>
            <i
              className="bi bi-trash3 iconTable"
              onClick={() => confirmBeforeDelete(row, true)}
            ></i>
          </span>
        </>
      ),
      width: "150px",
    },
    {
      name: t("msg_master_list.msg_checklist.code"),
      selector: (row) => row.checklistCode,
      sortable: true,
      width: "180px",
      cell: (row) => (
        <div>
          <p className="m-0 p-0 pt-1 fw-datatable-row">{row.checklistCode} </p>
        </div>
      ),
    },
    {
      name: t("msg_master_list.msg_checklist.checklist_name"),
      selector: (row) => row.checklistName,
      sortable: true,
      width: "250px",
      cell: (row) => (
        <div>
          <p className="m-0 p-0 pt-1 fw-datatable-row">{row.checklistName} </p>
        </div>
      ),
    },
    {
      name: t("msg_master_list.msg_checklist.related_departments"),
      selector: (row) => row.deptName,
      sortable: true,
      width: "250px",
      cell: (row) => (
        <div>
          <p className="m-0 p-0 pt-1 fw-datatable-row">{row.deptName} </p>
        </div>
      ),
    },
    {
      name: t("msg_master_list.msg_checklist.related_machines"),
      selector: (row) => row.machineCode,
      sortable: true,
      width: "250px",
      cell: (row) => (
        <div>
          <p className="m-0 p-0 pt-1 fw-datatable-row">{row.machineCode}: {row.machineName} </p>
        </div>
      ),
    },
    {
      name: t("msg_master_list.msg_checklist.checklistType"),
      selector: (row) => row.checklistTypeName,
      sortable: true,
      width: "200px",
      cell: (row) => (
        <div>
          <p className="m-0 p-0 pt-1 fw-datatable-row">{row.checklistTypeName} </p>
        </div>
      ),
    },
    {
      name: t("msg_common.status"),
      cell: (row) => (
        <>
          {row.checklistStatus === Constants.MASTER.STATUS.Active ? (
            <span className="bg-table-status bg-table-success-status">
              {t("msg_common.active")}
            </span>
          ) : row.checklistStatus === Constants.MASTER.STATUS.Inactive ? (
            <span className="bg-table-status bg-table-danger-status">
              {t("msg_common.inactive")}
            </span>
          ) : (
            row.checklistStatus
          )}
        </>
      ),
      center: true,
      width: "150px",
    },
    {
      name: t("msg_common.created_date"),
      selector: (row) => row.createdDate,
      sortable: true,
      cell: (row) => (
        <div>
          <p className="m-0 p-0 pt-1 fw-datatable-row">{formatDateTime(row?.createdDate)} </p>
        </div>
      ),
      center: true,
      width: "200px",
    },
  ];

  return (
    <main className="dashboard main" id="main">
      <Row className="justify-center subContent">
        <Col xs={8} md={8} className="rightSide">
          <div className="rightSideInner timesheet">
            <h2 className="mainTitle">
              {" "}
              {t("msg_master_list.msg_checklist.name")}
            </h2>
            <p className="subText">
              {t("msg_master_list.msg_checklist.details")}{" "}
            </p>
          </div>
        </Col>
        <Col xs={4} md={4} className="rightSide" >
        <Form>
                    <Form.Group>
                        <InputGroup>
                            <Form.Control
                                type="search"
                                placeholder={t("msg_common.search_placeholder")}
                                onChange={(e) => onSearchChange(e)}
                            />
                            <InputGroup.Text>
                            <i className="bi bi-search" onClick={handleSearch}></i>
                            </InputGroup.Text>
                        </InputGroup>
                    </Form.Group>
                </Form>
        </Col>
        <hr />
      </Row>
      <MasterList
        columnsData={columnsData}
        rowsData={rowsData}
        paginationRowsPerPageOptions={Constants.ROW_PER_PAGE}
        pagination
        selectableRows
        handleClose
        handleOpen={handleOpen}
        handleDelete={confirmBeforeDelete}
        handleRowSelected={handleRowSelected}
      />
      {open && (
        <ChecklistForm
          data={editMachines}
          show={open}
          onHide={handleClose}
          onSave={handleSave}
        ></ChecklistForm>
      )}
      {confirmModel && (
        <ConfirmationModal
          show={confirmModel}
          heading={t("msg_master_list.msg_checklist.delete_confirm_heading")}
          bodyMessage={t("msg_master_list.msg_checklist.delete_confirm_body")}
          onDelete={() => handleDelete()}
          onHide={() => setConfirmModel(false)}
          type={"delete"}
        ></ConfirmationModal>
      )}
      {isError && (
        <ErrorModal
          show={isError}
          heading={t("msg_master_list.msg_checklist.checklist_error_heading")}
          bodyMessage={error}
          onHide={() => {
            resetError();
          }}
        ></ErrorModal>
      )}
      {isAlert && (
        <AlertModal
          show={isAlert}
          heading={t("msg_common.alert")}
          bodyMessage={t("msg_common.selectRecord")}
          onHide={() => {
            resetAlert();
          }}
        ></AlertModal>
      )}
    </main>
  );
};

export default Checklist;
